export default __webpack_public_path__ + "static/03_嘉宾头像_李冬-4e9260a60910a6646560ab1bafa18e77.png";